
import {Component, Vue, Watch} from 'vue-property-decorator';
import {IFormBatch, IFormControl} from '@/interfaces/form';
import {fromTimestamp, rules, toTimestamp} from '@/utils';
import {readForm, readFormBatch, readFormBatches, readHasModuleAccess, readUserProfile} from '@/store/main/getters';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import {dispatchGetFormsAdmin} from '@/store/admin/actions';
import {
    dispatchCreateFormBatch,
    dispatchGetFormBatches,
    dispatchGetFormBatchesAdmin,
    dispatchUpdateFormBatch,
} from '@/store/main/actions';
import {readAdminForms} from '@/store/admin/getters';

@Component({
  components: {DefaultHelp},
})
export default class CRUDFormBatch extends Vue {
  private FBTitle: string = `${this.$t('crud.create')} ${this.$t('form_batch')}`;
  private rules: any = rules;
  private valid: boolean = true;
  private formBathID: number = -1;
  private nameField: string = '';
  private fromField: any = null;
  private toField: any = null;
  private menu1: boolean = false;
  private date: any = null;
  private formBatch: IFormBatch = {} as IFormBatch;
  private dateStr: string = '';
  private currentMethod: string = 'create';

  private routeParams: any;
  private selectedItem: any = null;
  private selectedItemSearch: any = null;
  private selectedItemSearchItems: any = [];

  public async mounted() {
    this.reset();
    this.loadMountedSettings();
  }

  public beforeRouteLeave(to, from, next) {
    this.reset();
    next();
  }

  @Watch('date')
  private changeDateValue(val, oldValue) {
    if (!val) {
      return null;
    }
    this.formBatch.released_at = toTimestamp(val);
    const [year, month, day] = val.split('-');
    this.dateStr = `${day}/${month}/${year}`;
  }

  private async loadMountedSettings() {
    this.FBTitle = `${this.$t('crud.create')} ${this.$t('form_batch')}`;
    this.formBathID = this.$router.currentRoute.params.id as unknown as number;
    this.routeParams = this.$router?.currentRoute?.params?.item;
    if (this.forms?.length === 0) {
      await dispatchGetFormsAdmin(this.$store);
    }

    // this.date = new Date().toISOString().substr(0, 10);

    if (this.formBathID > 0) {
      this.FBTitle = `${this.$t('crud.update')} ${this.$t('form_batch')}`;
      this.currentMethod = 'update';
      if (readFormBatches(this.$store)?.length === 0) {
        await dispatchGetFormBatchesAdmin(this.$store, {with_stats: false, skip: 0, limit: -1});
      }
      this.formBatch = readFormBatch(this.$store)(+this.formBathID) as unknown as IFormBatch;
      if (!this.formBatch) {
        return;
      }
      // @ts-ignore
      this.selectedItem = await readForm(this.$store)(+this.formBatch?.form_id);
      await this.showValue(this.selectedItem);
      this.selectedItemSearch = this.formBatch?.field_reference;
      // @ts-ignore
      if (this.formBatch && this.formBatch?.range_values?.length > 1) {
        // @ts-ignore
        this.fromField = this.formBatch.range_values[0];
        // @ts-ignore
        this.toField = this.formBatch.range_values[1];
      }
      if (this.formBatch.released_at) {
        this.dateStr = fromTimestamp(this.formBatch.released_at);
      }

    } else if (this.routeParams) {
      this.nameField = `Requisição de formulário [${this.routeParams?.id}] - ${this.routeParams?.origin_request}`;
    } else {
      this.formBatch.origin_request =
          //  @ts-ignore
        readUserProfile(this.$store)?.role?.settings?.custom_data.find((e: any) => e?.name === 'hospital_name')?.value;
    }
  }

  private get forms() {
    return readAdminForms(this.$store);
  }

  private reset() {
    this.formBatch = {} as IFormBatch;
    this.formBathID = 0;
    this.selectedItem = null;
    this.selectedItemSearch = null;
    this.toField = null;
    this.fromField = null;
    this.selectedItemSearchItems = [];
  }

  private async showValue(item) {
    this.selectedItemSearchItems = [];
    if (item) {
      const cForm = JSON.parse(JSON.stringify(item?.form_setting?.form_data.controls));
      if (!cForm) {
        return;
      }
      await Object.entries(cForm).forEach((e) => {
        const element = Object.assign(e[1], {} as IFormControl);
        const cValue = element.label !== '' ? element.label : (element.name !== '' ? element.name : element.uniqueId);
        const cName = element.name !== '' ? element.name : element.uniqueId;
        this.selectedItemSearchItems.push({key: cName, text: cValue});
      });
    }
  }

  private async save() {
    // @ts-ignore
    const form: any = this.$refs.form_fb;
    if (form.validate()) {
      this.formBatch.form_id = this.selectedItem.id;
      this.formBatch.version = this.selectedItem.version;
      this.formBatch.field_reference = this.selectedItemSearch.key;
      this.formBatch.range_values = [Number(this.fromField), Number(this.toField)];

      if (this.formBathID > 0) {
        this.formBatch.id = this.formBathID;
        if (await dispatchUpdateFormBatch(this.$store, this.formBatch)) {
          this.$router.push({name: 'main-admin-form-batch-list'});
        }
      } else {
        if (await dispatchCreateFormBatch(this.$store, this.formBatch)) {
          this.$router.push({name: 'main-admin-form-batch-list'});
        }
      }
    }
  }

  private cancel() {
    this.$router.back();
  }

  private get hasAccess() {
    return readHasModuleAccess(this.$store)({module: 'form_batch_admin', method: this.currentMethod});
  }

}
